<div class="card-body"
     [ngClass]="accClass"
     [class.card-body-sm]="size === 'sm'">
  <ng-content></ng-content>
</div>
